var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "nav" },
    _vm._l(_vm.routers, function (item, index) {
      return _c(
        "router-link",
        {
          key: index,
          attrs: { to: item.path, tag: "li", "data-io-click": "tracker" },
        },
        [_vm._v(_vm._s(item.name))]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }